<template>
  <el-dialog
    title="修改手机号"
    :visible.sync="dialogVisible"
    width="50%"
    append-to-body
    :before-close="handleCancel"
  >
    <ContactForm :isShop="true" :hideWx="true" ref="contactForm" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ContactForm from '@/components/base/ContactForm.vue';
import { getEditContactInfo } from '@servers/commodity/index';
import { checkVerifyCode } from '@servers/base/contact/index.js';

export default {
  data() {
    return {
      dialogVisible: false,
      phone: ''
    }
  },
  components: {
    ContactForm
  },
  methods: {
    method_open(phone) {
      this.phone = phone;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.contactForm?.updateValue({
          phone: phone,
          wx: '',
          companyName: '',
          contact: ''
        });
      });
    },
    handleSure() {
      this.$refs.contactForm.validate(async (valid) => {
        if (valid) {
          let contact_data = this.$refs.contactForm.getFormData();
          const coderes = await checkVerifyCode({
            phoneNum: contact_data.phone,
            identityCode: contact_data.verifyCode,
            status: 0
          });
          if (!coderes) return;
          const res = await getEditContactInfo(contact_data);
          if (!res) return;
          this.$emit('success', { phone: contact_data.phone });
          this.$message.success('修改成功');
          this.handleCancel();
        }
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$refs.contactForm?.resetFields();
    }
  }
}
</script>
